import DefaultInput from 'components/input/DefaultInput';
import React from 'react';
import styled from 'styled-components';
/**
 * * 작품 관리 - DLC - 에피소드 로컬라이징
 */
const DLCEpisodeLocalizingForm = ({ langList, onChange }) => {
  return (
    <LocalizingForm>
      {langList?.map((v) => (
        <div className='section_input'>
          <DefaultInput
            title='제목'
            name='title'
            id={`${v.lang}`}
            value={v.title}
            onChange={onChange}
            codeName={v.code_name ? v.code_name : ''}
            maxLength={30}
            top='true'
            localizing
            style={{ marginLeft: '0.5rem' }}
          />
        </div>
      ))}
    </LocalizingForm>
  );
};

export default DLCEpisodeLocalizingForm;
const LocalizingForm = styled.form`
  .section_input {
    /* border-bottom: 1px solid rgba(217, 222, 227, 0.5); */
    margin-bottom: ${(props) => (props.projectType === 0 ? '4rem' : '2rem')};
    /* padding-bottom: 2rem; */
  }
`;
